/**
 * @generated SignedSource<<401cdab8074d41d78b640d3ad4b1c2fa>>
 * @relayHash cb353b2f3865d0fb91b0caaff7dccdf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a658ee7d7110710d7d057d121af02e3c48cbcac92f3d9ba85a4a036db7ecbdb4

import type { ConcreteRequest } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type GrowthUnifiedProfileTrialTrigger = "AUTO_UPGRADE_STORAGE_LIMIT" | "AUTO_UPGRADE_USER_LIMIT" | "CROSSFLOW_USER_LIMIT" | "EDITION_PARITY" | "EDITION_PARITY_AUTO_PROVISIONING" | "REACTIVATION" | "REVERSE_TRIAL" | "UI" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_CUSTOMER_SERVICE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null> | null;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null> | null;
  hasRelationshipFromWithType?: string | null;
  inPreDunning?: boolean | null;
  inTrialOrPreDunning?: boolean | null;
};
export type editionAwarenessQuery$variables = {
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null;
  productKey: string;
  shouldCheckForAddPaymentDetails: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForDirectBuyChangeOffering: boolean;
  shouldCheckForPaymentDetails: boolean;
  shouldCheckForStorageLimit: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForTrial: boolean;
};
export type editionAwarenessQuery$data = {
  readonly jira?: {
    readonly attachmentStorageAllowed?: AGG$Long | null;
    readonly attachmentStorageIsUnlimited?: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly entitlementProfile: {
          readonly lastKnownTrial: {
            readonly createdAt: number | null;
            readonly offeringId: string | null;
            readonly trialEndTimeStamp: number | null;
            readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null;
            readonly trialType: GrowthUnifiedProfileTrialType | null;
          } | null;
        } | null;
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
          readonly changeOfferingV2WithSkipTrial?: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
        } | null;
        readonly latestUsageForChargeElement?: number | null;
        readonly offering?: {
          readonly key: string | null;
          readonly trial: {
            readonly lengthDays: number | null;
          } | null;
        } | null;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null;
        } | null;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
        readonly relatesFromEntitlementsWithCollectionType: ReadonlyArray<{
          readonly entitlement: {
            readonly entitlementProfile: {
              readonly lastKnownTrial: {
                readonly createdAt: number | null;
                readonly offeringId: string | null;
                readonly trialEndTimeStamp: number | null;
                readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null;
                readonly trialType: GrowthUnifiedProfileTrialType | null;
              } | null;
            } | null;
            readonly preDunning: {
              readonly status: CcpEntitlementPreDunningStatus | null;
            } | null;
          } | null;
        } | null> | null;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null;
                  readonly isAvailableToUser: boolean | null;
                } | null;
              } | null;
              readonly invoiceable: boolean | null;
            } | null;
          } | null;
          readonly trial: {
            readonly endTimestamp: number | null;
            readonly startTimestamp: number | null;
            readonly timeLeft: number | null;
          } | null;
        } | null;
        readonly transactionAccount: {
          readonly experienceCapabilities?: {
            readonly addPaymentMethodV2: {
              readonly experienceUrl: string | null;
              readonly isAvailableToUser: boolean | null;
            } | null;
          } | null;
          readonly isBillToPresent?: boolean | null;
          readonly isCurrentUserBillingAdmin: boolean | null;
          readonly key: string | null;
        } | null;
      } | null;
      readonly entitlementId: string;
    } | null;
  } | null> | null;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForAddPaymentDetails"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForDirectBuyChangeOffering"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForPaymentDetails"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageLimit"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v12 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "applicationKey"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v13 = {
  "condition": "shouldCheckForStorageUsageJira",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckForStorageLimit",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v12/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageAllowed"
            },
            {
              "args": (v12/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageIsUnlimited"
            }
          ]
        },
        {
          "args": (v12/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        }
      ]
    }
  ]
},
v14 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v15 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v17 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v18 = {
  "kind": "Literal",
  "name": "offeringName",
  "value": "Standard"
},
v19 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v20 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v21 = [
  (v19/*: any*/),
  (v20/*: any*/)
],
v22 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        (v18/*: any*/)
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": (v21/*: any*/),
      "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
    },
    {
      "condition": "shouldCheckForDirectBuyChangeOffering",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "changeOfferingV2WithSkipTrial",
          "args": [
            (v18/*: any*/),
            {
              "kind": "Literal",
              "name": "skipTrial",
              "value": true
            }
          ],
          "concreteType": "CcpChangeOfferingExperienceCapability",
          "kind": "LinkedField",
          "name": "changeOfferingV2",
          "plural": false,
          "selections": (v21/*: any*/),
          "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
        }
      ]
    }
  ]
},
v23 = {
  "condition": "shouldCheckForChargeQuantities",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chargeElement",
          "variableName": "chargeElement"
        }
      ],
      "kind": "ScalarField",
      "name": "latestUsageForChargeElement"
    }
  ]
},
v24 = {
  "concreteType": "CcpEntitlementPreDunning",
  "kind": "LinkedField",
  "name": "preDunning",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v25 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeLeft"
    },
    {
      "kind": "ScalarField",
      "name": "startTimestamp"
    },
    {
      "kind": "ScalarField",
      "name": "endTimestamp"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v27 = {
  "concreteType": "CcpInvoiceGroupExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
      "kind": "LinkedField",
      "name": "configurePaymentV2",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        (v19/*: any*/)
      ]
    }
  ]
},
v28 = {
  "concreteType": "CcpOfferingTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lengthDays"
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "key"
},
v30 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v31 = {
  "condition": "shouldCheckForPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isBillToPresent"
        }
      ]
    }
  ]
},
v32 = {
  "condition": "shouldCheckForAddPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "concreteType": "CcpTransactionAccountExperienceCapabilities",
          "kind": "LinkedField",
          "name": "experienceCapabilities",
          "plural": false,
          "selections": [
            {
              "concreteType": "CcpAddPaymentMethodExperienceCapability",
              "kind": "LinkedField",
              "name": "addPaymentMethodV2",
              "plural": false,
              "selections": (v21/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v33 = {
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "relationshipType"
    },
    (v16/*: any*/)
  ]
},
v34 = [
  {
    "kind": "Literal",
    "name": "relationshipTypes",
    "value": "COLLECTION"
  }
],
v35 = {
  "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
  "kind": "LinkedField",
  "name": "entitlementProfile",
  "plural": false,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
      "kind": "LinkedField",
      "name": "lastKnownTrial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "trialType"
        },
        {
          "kind": "ScalarField",
          "name": "trialTrigger"
        },
        {
          "kind": "ScalarField",
          "name": "trialEndTimeStamp"
        },
        {
          "kind": "ScalarField",
          "name": "createdAt"
        },
        {
          "kind": "ScalarField",
          "name": "offeringId"
        }
      ]
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      (v13/*: any*/),
      {
        "args": (v14/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v17/*: any*/),
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v24/*: any*/),
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "concreteType": "CcpAccountDetails",
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CcpInvoiceGroup",
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v27/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "CcpOffering",
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              (v29/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          (v30/*: any*/)
                        ]
                      },
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": "relatesFromEntitlementsWithCollectionType",
                        "args": (v34/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v35/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v35/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v11/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v10/*: any*/),
      (v0/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "args": (v14/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v16/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v17/*: any*/),
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v36/*: any*/)
                        ]
                      },
                      (v33/*: any*/),
                      {
                        "alias": "relatesFromEntitlementsWithCollectionType",
                        "args": (v34/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v23/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v24/*: any*/),
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "concreteType": "CcpAccountDetails",
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CcpInvoiceGroup",
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v36/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v36/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "CcpOffering",
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v36/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      },
      (v13/*: any*/)
    ]
  },
  "params": {
    "id": "a658ee7d7110710d7d057d121af02e3c48cbcac92f3d9ba85a4a036db7ecbdb4",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "93c4734e5bd8995469febba08894cd2f";

export default node;
